<template>
  <v-btn
    small
    text
    rounded
    outlined
    :to="{ name: 'ToolProcessView', params: { name: toolname }}"
  >
    <v-icon small left>fas fa-cog</v-icon>
    {{ toolname }}
  </v-btn>
</template>

<script>
export default {
  name: "ToolNavigation",
  props: {
    toolname: {
      type: String,
      required: true
    }
  }
}
</script>
